import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Box,
  HStack,
  VStack,
  Text,
  Center,
  ScrollView,
  Button,
  useToast,
  Stack,
  TextArea,
  View,
  FormControl,
  Input,
  Image,
  Select,
  Icon,
  Pressable,
  Heading,
  ChevronUpIcon,
  IconButton,
} from "native-base";
import { GlobalStyles } from "../../constants/styles";
import { GlobalConstants } from "../../constants/constants";
import DatePickerSingleInput from "../../components/DatePickerSingleInput";
import ConfigureSettingsPopup from "../../components/ConfigureSettingsPopup";
import DateRangePickerModel from "../../components/DateRangePickerModel";
import Toast from "../../components/Toast";
import { useSelector } from "react-redux";
import axios from "axios";
import { Ionicons, MaterialIcons } from "@expo/vector-icons";
import { uploadImage } from "../../utils/general";
// import AdCard from "../../components/AdCard";
import AdCardForBusiness from "../../components/AdCardForBusiness";
import StripePopup from "../../components/StripePopup";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import Quill's CSS

const AdvertiserMainPage = () => {
  let user = useSelector((state) => state.user.user);
  axios.defaults.headers.common = {
    Authorization: `bearer ${user ? user.token : null}`,
  };

  const toast = useToast();

  const [isNewAdSelected, setIsNewAdSelected] = useState(false);
  const [isCurrentAdsSelected, setIsCurrentAdsSelected] = useState(false);
  const [isAnalyticsSelected, setIsAnalyticsSelected] = useState(false);

  const [isShowPayNow, setIsShowPayNow] = useState(false);
  const [payNowPayload, setPayNowPayload] = useState({
    ad_id: 0,
    amount: 0,
  });
  const [showPayNowCard, setShowPayNowCard] = useState(false);

  const [adCategories, setAdCategories] = useState([]);
  const [ads, setAds] = useState([]);
  const [hasMorePosts, setHasMorePosts] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const [open, setOpen] = useState(false);

  const [submitPopUp, setSubmitPopUp] = useState(false);
  const [deletePopUp, setDeletePopUp] = useState(false);
  const [selectedPost, setSelectedPost] = useState({});
  /// For ReactQuill editor
  const [remainingCharacters, setRemainingCharacters] = useState(300);
  const [remainingCharactersForDetail, setRemainingCharactersForDetail] = useState(1500);
  const summaryRef = useRef(null);
  const detailRef = useRef(null);
  const [postTextArea, setPostTextArea] = useState("");
  const [postDetails, setPostDetails] = useState("");
  const [postImage, setPostImage] = useState([]);
  const [youtubeLink, setYoutubeLink] = useState("");

  const [currentAdsBtnTextColor, setCurrentAdsBtnTextColor] = useState(
    GlobalStyles.colors.blue
  );
  const [analyticsBtnTextColor, setAnalyticsBtnTextColor] = useState(
    GlobalStyles.colors.blue
  );
  const [newAdBtnTextColor, setNewAdBtnTextColor] = useState(
    GlobalStyles.colors.blue
  );

  function changeColor(btnType) {
    if (btnType === "NewAd") {
      setCurrentAdsBtnTextColor(GlobalStyles.colors.blue);
      setAnalyticsBtnTextColor(GlobalStyles.colors.blue);
      setNewAdBtnTextColor(GlobalStyles.colors.mustard);
      setIsNewAdSelected(true);
      setIsCurrentAdsSelected(false);
      setIsAnalyticsSelected(false);
    } else if (btnType === "CurrentAds") {
      setCurrentAdsBtnTextColor(GlobalStyles.colors.mustard);
      setAnalyticsBtnTextColor(GlobalStyles.colors.blue);
      setNewAdBtnTextColor(GlobalStyles.colors.blue);
      setIsNewAdSelected(false);
      setIsCurrentAdsSelected(true);
      setIsAnalyticsSelected(false);
    } else if (btnType === "Analytics") {
      setCurrentAdsBtnTextColor(GlobalStyles.colors.blue);
      setAnalyticsBtnTextColor(GlobalStyles.colors.mustard);
      setNewAdBtnTextColor(GlobalStyles.colors.blue);
      setIsNewAdSelected(false);
      setIsCurrentAdsSelected(false);
      setIsAnalyticsSelected(true);
    } else {
      setCurrentAdsBtnTextColor(GlobalStyles.colors.blue);
      setAnalyticsBtnTextColor(GlobalStyles.colors.blue);
      setNewAdBtnTextColor(GlobalStyles.colors.mustard);
      setIsNewAdSelected(true);
      setIsCurrentAdsSelected(false);
      setIsAnalyticsSelected(false);
    }
  }

  const [payload, setPayload] = useState({
    ad_category_id: 0,
    start_date: "",
    end_date: "",
    urls: [],
    text: "",
    detail: "",
  });

  const refresh = () => {
    setPayload({
      ad_category_id: 0,
      start_date: "",
      end_date: "",
      urls: [],
      text: "",
      detail: "",
    });
  };

  function validateForm() {
    if (!payload.ad_category_id) {
      toast.show({
        render: () => {
          return (
            <Toast
              color={GlobalStyles.colors.red}
              message={"please select Ad Type!!!"}
            />
          );
        },
        placement: "top",
      });
      return false;
    } else if (!payload.urls[0]) {
      toast.show({
        render: () => {
          return (
            <Toast
              color={GlobalStyles.colors.red}
              message={"please upload image!!!"}
            />
          );
        },
        placement: "top",
      });
      return false;
    } else if (!payload.start_date || !payload.start_date) {
      toast.show({
        render: () => {
          return (
            <Toast
              color={GlobalStyles.colors.red}
              message={"please select date range!!!"}
            />
          );
        },
        placement: "top",
      });
      return false;
    }
    // else if (!payload.text) {
    //   toast.show({
    //     render: () => {
    //       return (
    //         <Toast
    //           color={GlobalStyles.colors.red}
    //           message={"please enter ad text!!!"}
    //         />
    //       );
    //     },
    //     placement: "top",
    //   });
    //   return false;
    // }
    return payload;
  }

  const Submit = async (e) => {
  let _payload = validateForm();

  console.log("payload", _payload);

  if (_payload) {
    try {
      const resp = await axios.post(
        `${GlobalConstants.townTicksBaseUrl}ad`,
        _payload
      );

      if (resp.data.status) {
        const adStatus = resp.data.data?.status;

        // Reset media states
        setPostImage([]);
        setYoutubeLink(""); // NEW
        setPostTextArea("");
        setPostDetails("");

        // Reset payload
        refresh(); // NEW

        // Payment logic remains same
        if (adStatus !== "ACTIVE") {
          setPayNowPayload({
            ad_id: resp.data.data.id,
            amount: resp.data.amount,
          });

          setIsShowPayNow(true);
        } else {
          toast.show({
            render: () => {
              return (
                <Toast
                  color={GlobalStyles.colors.green}
                  message="Ad Created by Novelma User"
                />
              );
            },
            placement: "top",
          });
        }
      } else {
        toast.show({
          render: () => {
            return (
              <Toast
                color={GlobalStyles.colors.red}
                message={resp.data.status_msg}
              />
            );
          },
          placement: "top",
        });
      }
    } catch (error) {
      console.log("AD ERROR:", error);

      toast.show({
        render: () => {
          return (
            <Toast
              color={GlobalStyles.colors.red}
              message={
                error?.response?.data?.status_msg ||
                "Something went wrong"
              }
            />
          );
        },
        placement: "top",
      });
    }
  }
};

  const Delete = async () => {
    console.log("id", selectedPost.id)
    let config = {
      method: "delete",
      maxBodyLength: Infinity,
      url: `${GlobalConstants.townTicksBaseUrl}ad`,
      headers: {
        "Content-Type": "application/json",
      },
      data: JSON.stringify({
        ad_id: selectedPost.id,
      }),
    };

    axios
      .request(config)
      .then((resp) => {
        console.log("status for delete ", resp.data, resp.data.status)
        if (resp.data.status) {
          refresh();
          setSubmitPopUp(false);
          toast.show({
            render: () => {
              return (
                <Toast
                  color={GlobalStyles.colors.green}
                  message={resp.data.status_msg}
                />
              );
            },
            placement: "top",
            duration: 3000,
          });
        } else {
          toast.show({
            render: () => {
              return (
                <Toast
                  color={GlobalStyles.colors.red}
                  message={resp.data.status_msg}
                />
              );
            },
            placement: "top",
            duration: 3000,
          });
        }
      })
      .catch((error) => {
        toast.show({
          render: () => {
            return <Toast color={GlobalStyles.colors.red} message={error} />;
          },
          placement: "top",
        });
      });
  };

  const convertDate = (inputFormat) => {
    function pad(s) {
      return s < 10 ? "0" + s : s;
    }
    var d = new Date(inputFormat);
    return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join("-");
  };

  const getAdCategories = async () => {
    try {
      const resp = await axios.get(
        `${GlobalConstants.townTicksBaseUrl}ad/category`
      );
      if (resp.data.status) {
        setAdCategories(resp.data.data);
      } else {
        toast.show({
          render: () => {
            return (
              <Toast
                color={GlobalStyles.colors.red}
                message={"Failed to get ad categories!!!"}
              />
            );
          },
          placement: "top",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getAds = async () => {
    try {
      const resp = await axios.get(`${GlobalConstants.townTicksBaseUrl}ad`);
      if (resp.data.status) {
        setAds(resp.data.data);
      } else {
        toast.show({
          render: () => {
            return (
              <Toast
                color={GlobalStyles.colors.red}
                message={"Failed to get ads!!!"}
              />
            );
          },
          placement: "top",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  async function selectFile() {
    if (youtubeLink.trim()) {
    toast.show({
      description: "Remove YouTube link first",
    });
    return;
  }
    setIsLoading(true);
    let mediaUrl = await uploadImage(user.token); // image/video uploader

  if (mediaUrl) {
    setPostImage((prev) => {
      const updated = [...prev, mediaUrl];

      setPayload((p) => ({
        ...p,
        urls: updated,
      }));

      return updated;
    });
    setIsLoading(false);
  } else {
      setIsLoading(false);
      toast.show({
        render: () => {
          return (
            <Toast
              color={GlobalStyles.colors.red}
              message={"please check image size should be less than 500KB!!!"}
            />
          );
        },
        placement: "top",
      });
    }
  };
  const removeImage = (index) => {
  const updated = postImage.filter((_, i) => i !== index);

  setPostImage(updated);

    setPayload((prev) => ({
      ...prev,
      urls: updated,
    }));
  };

  const handleYoutubeLink = (value) => {
  setYoutubeLink(value);

  setPayload((prev) => ({
    ...prev,
    urls: value ? [value] : [],
  }));
};
  // async function selectFile() {
  //   setIsLoading(true);
  //   let imageUrl = await uploadImage();
  //   if (imageUrl) {
  //     const _payload = { ...payload };
  //     _payload.urls[0] = imageUrl;
  //     setPayload(_payload);
  //     setIsLoading(false);
  //   } else {
  //     toast.show({
  //       render: () => {
  //         return (
  //           <Toast
  //             color={GlobalStyles.colors.red}
  //             message={"please check image size should be less than 500KB!!!"}
  //           />
  //         );
  //       },
  //       placement: "top",
  //     });
  //   }
  // }
  // for ReactQuill Editor

  const handleCountInputChange = (value) => {

    const plainTextLength = value.replace(/<[^>]*>/g, "").length;

    if (plainTextLength <= 300) {
      setPostTextArea(value);
      // console.log(postTextArea,value,"data text")
      setPayload((prev) => ({ ...prev, text: value }));
      // if (boxRef.current) {
      //   const el = boxRef.current;
      //   requestAnimationFrame(() => {
      //     el.scrollTop = el.scrollHeight;
      //   });
      // }
      setRemainingCharacters(300 - plainTextLength);
    } else {
      const truncatedText = truncateToLimit(value, 300);
      setPostTextArea(truncatedText);
      setPayload((prev) => ({ ...prev, text: truncatedText }));
      // if (boxRef.current) {
      //   const el = boxRef.current;
      //   requestAnimationFrame(() => {
      //     el.scrollTop = el.scrollHeight;
      //   });
      // }
      setRemainingCharacters(0);
    }
  };
  const handleCountInputChangeForDetail = (value) => {

    const plainTextLength = value.replace(/<[^>]*>/g, "").length;

    if (plainTextLength <= 1500) {
      setPostDetails(value);
      setPayload((prev) => ({ ...prev, detail: value }));
      // if (boxRef.current) {
      //   const el = boxRef.current;
      //   requestAnimationFrame(() => {
      //     el.scrollTop = el.scrollHeight;
      //   });
      // }
      setRemainingCharactersForDetail(1500 - plainTextLength);
    } else {
      const truncatedText = truncateToLimit(value, 1500);
      setPostDetails(truncatedText);
      setPayload((prev) => ({ ...prev, detail: truncatedText }));
      // if (boxRef.current) {
      //   const el = boxRef.current;
      //   requestAnimationFrame(() => {
      //     el.scrollTop = el.scrollHeight;
      //   });
      // }
      setRemainingCharactersForDetail(0);

    }
  };

  const truncateToLimit = (htmlContent, limit) => {
    const div = document.createElement("div");
    div.innerHTML = htmlContent;

    let charCount = 0;
    let reachedLimit = false;

    const truncateNode = (node) => {
      if (reachedLimit) return null;

      if (node.nodeType === Node.TEXT_NODE) {
        const text = node.textContent || "";
        if (charCount + text.length <= limit) {
          charCount += text.length;
          return document.createTextNode(text);
        } else {
          const remaining = limit - charCount;
          charCount = limit;
          reachedLimit = true;
          return document.createTextNode(text.slice(0, remaining));
        }
      }

      if (node.nodeType === Node.ELEMENT_NODE) {
        const clone = node.cloneNode(false); // Shallow clone
        for (const child of node.childNodes) {
          const truncatedChild = truncateNode(child);
          if (truncatedChild) clone.appendChild(truncatedChild);
          if (reachedLimit) break;
        }
        return clone;
      }

      return null;
    };

    const truncated = truncateNode(div);
    const container = document.createElement("div");
    if (truncated) container.appendChild(truncated);

    return container.innerHTML;
  };

  useEffect(() => {
    console.log(window?.innerWidth || yourDefaultWidth);
    const updateLinkButton = () => {
      const toolbars = document.querySelectorAll(".ql-toolbar");

      toolbars.forEach((toolbar) => {
        const linkButton = toolbar.querySelector(".ql-formats");

        if (linkButton && !linkButton.classList.contains("customized")) {
          linkButton.classList.add("customized");

          const labelSpan = document.createElement("span");
          labelSpan.textContent = " Make hyperlink";
          labelSpan.style.marginLeft = "4px";
          labelSpan.style.fontSize = "14px";
          labelSpan.style.verticalAlign = "middle";

          linkButton.appendChild(labelSpan);
        }
      });
    };
    const editor1 = summaryRef.current?.getEditor();
    const editor2 = detailRef.current?.getEditor();

    if (editor1) {
      editor1.on("text-change", () => {
        const plain = editor1.getText().trim();
        if (plain.length > 300) {
          editor1.deleteText(300, plain.length);
        }
      });
    }

    if (editor2) {
      editor2.on("text-change", () => {
        const plain = editor2.getText().trim();
        if (plain.length > 1500) {
          editor2.deleteText(1500, plain.length);
        }
      });
    }

    // Apply the update after component mounts
    updateLinkButton();
    changeColor("NewAd");
    getAdCategories();
  }, []);

  const handleChange = useCallback(async (value) => {
    setSubmitPopUp(false);
    window.location.reload();
  }, []);

  const handleDeleteOk = async (isTrue) => {
    setDeletePopUp(false);
    if (isTrue) {
      await Delete();
      getAds();
    }
  };
  ////// for scroll up to the top //////
  const [showUpButton, setShowUpButton] = useState(false);
  const scrollViewRef = useRef(null);
  const scrollToTop = () => {
    console.log("up to the screen.", scrollViewRef.current)
    if (scrollViewRef.current) {
      scrollViewRef.current.scrollTo({ y: 0, animated: true });
    }
  };
  const handleScroll = (event) => {
    const scrollY = event.nativeEvent.contentOffset.y;
    setShowUpButton(scrollY > 100); // Show button when user scrolls down 100px
  };

  const handlePayNow = useCallback(async (value) => {
    setIsShowPayNow(false);
    setShowPayNowCard(true);
  }, []);

  const onDeleteClick = async (data) => {
    console.log(data);
    setDeletePopUp(true);
    setSelectedPost(data);
  };

  return (
    <>
      <ScrollView ref={scrollViewRef} onScroll={handleScroll}
        scrollEventThrottle={16}>
        {user &&
          user.user_category == GlobalConstants.userCategories.business.id ? (
          <Center>
            <Box safeAreaTop bg="white" />
            <Box
            bg="#F5F5F5"
            px="1"
            py="3"
            justifyContent="space-between"
            alignItems="center"
            w="100%"
            maxW="900"
          >
            <Stack
              mt={5}
              w={[230, 430, 530]}
              justifyContent="center"
              flexDirection={"row"}
            >
              <Button
                size="sm"
                mx={1}
                variant={"solid"}
                px="3"
                bg={GlobalStyles.colors.blue}
                borderColor={GlobalStyles.colors.white}
                borderWidth={2}
                onPress={() => {
                  window.location.reload();
                  // getPostsByCategoryId(
                  //   GlobalConstants.postCategories.tick.id
                  // );
                }}
                leftIcon={
                  <Image source={require("../../../assets/tick.png")} alt="icon" size="5" />
                }
              >
                <Text
                  fontWeight="bold"
                  fontFamily={GlobalStyles.text.fontFamily}
                  color={GlobalStyles.colors.white}
                >
                  Ticks
                </Text>
              </Button>
               <Button
                    size="sm"
                    mx={1}
                    variant={"solid"}
                    px="3"
                    bg={GlobalStyles.colors.blue}
                    borderColor={GlobalStyles.colors.white}
                    borderWidth={2}
                    onPress={() => {
                      window.location.reload();
                      // getPostsByCategoryId(
                      //   GlobalConstants.postCategories.deal.id
                      // );
                    }}
                    leftIcon={
                      <Image source={require("../../../assets/deals.png")} alt="icon" size="5"  />
                    }
                  >
                    <Text
                      fontWeight="bold"
                      fontFamily={GlobalStyles.text.fontFamily}
                      color={GlobalStyles.colors.white}
                    >
                      Deals
                    </Text>
                  </Button>
                  <Button
                    // isDisabled={true}
                    size="sm"
                    variant={"solid"}
                    mx={1}
                    px="3"
                    bg={GlobalStyles.colors.blue}
                    borderColor={GlobalStyles.colors.mustard}
                    borderWidth={2}
                    // onPress={() => {
                    //   navigation.navigate("AdvertiserMainPage");
                    // }}
                    leftIcon={
                      <Image source={require("../../../assets/colorAds.png")} alt="icon" size="5"  />
                    }
                  >
                    <Text
                      fontWeight="bold"
                      fontFamily={GlobalStyles.text.fontFamily}
                      color={GlobalStyles.colors.mustard}
                    >
                       Ads
                    </Text>
                  </Button>
                  <Button
                  // isDisabled={true}
                    size="sm"
                    mx={1}
                    variant={"solid"}
                    px="3"
                    bg={GlobalStyles.colors.blue}
                    borderColor={GlobalStyles.colors.white}
                    borderWidth={2}
                    onPress={() => {
                      window.location.reload();
                      // getPostsByCategoryId(
                      //   GlobalConstants.postCategories.deal.id
                      // );
                    }}
                    leftIcon={
                      <Image source={require("../../../assets/icons_services.png")} alt="icon" size="5"  />
                    }
                  >
                    <Text
                      fontWeight="bold"
                      fontFamily={GlobalStyles.text.fontFamily}
                      color={GlobalStyles.colors.white}
                    >
                      Services
                    </Text>
                  </Button>
                  <Button
                    size="sm"
                    mx={1}
                    variant={"solid"}
                    px="3"
                    bg={GlobalStyles.colors.blue}
                    borderColor={GlobalStyles.colors.white}
                    borderWidth={2}
                    onPress={() => {
                      window.location.reload();
                      // getPostsByCategoryId(
                      //   GlobalConstants.postCategories.deal.id
                      // );
                    }}
                    leftIcon={
                      <Image source={require("../../../assets/ix_product.png")} alt="icon" size="5"  />
                    }
                  >
                    <Text
                      fontWeight="bold"
                      fontFamily={GlobalStyles.text.fontFamily}
                      color={GlobalStyles.colors.white}
                    >
                      Products
                    </Text>
                  </Button>
                  
                </Stack>
            </Box> 
          </Center>
        ) : (
          <></>
        )}

        <Box>
          <Center>
            <Box safeAreaTop bg="white" />
            <Box
              h={"550"}
              bg="#F5F5F5"
              px="1"
              py="3"
              justifyContent="space-between"
              alignItems="center"
              w="100%"
              maxW="900"
            >
              <VStack alignItems="center">
                <Stack
                  mt={5}
                  w={[230, 230, 230]}
                  justifyContent="center"
                  flexDirection={"row"}
                >
                  <Button
                    size="sm"
                    mx={1}
                    variant={"solid"}
                    px="2"
                    bg={GlobalStyles.colors.white}
                    borderColor={currentAdsBtnTextColor}
                    borderWidth={2}
                    borderRadius={40}
                    onPress={() => {
                      changeColor("CurrentAds");
                      getAds();
                    }}
                  >
                    <Text
                      fontWeight="bold"
                      fontFamily={GlobalStyles.text.fontFamily}
                      color={currentAdsBtnTextColor}
                    >
                      Your Ads
                    </Text>
                  </Button>
                  <Button
                    size="sm"
                    variant={"solid"}
                    mx={1}
                    px="2"
                    bg={GlobalStyles.colors.white}
                    borderColor={newAdBtnTextColor}
                    borderWidth={2}
                    borderRadius={40}
                    onPress={() => {
                      changeColor("NewAd");
                    }}
                  >
                    <Text
                      fontWeight="bold"
                      fontFamily={GlobalStyles.text.fontFamily}
                      color={newAdBtnTextColor}
                    >
                      New Ad
                    </Text>
                  </Button>
                  <Button
                    size="sm"
                    mx={1}
                    variant={"solid"}
                    px="2"
                    bg={GlobalStyles.colors.white}
                    borderColor={analyticsBtnTextColor}
                    borderWidth={2}
                    borderRadius={40}
                    onPress={() => {
                      changeColor("Analytics");
                      getAds();
                    }}
                  >
                    <Text
                      fontWeight="bold"
                      fontFamily={GlobalStyles.text.fontFamily}
                      color={analyticsBtnTextColor}
                    >
                      Analytics
                    </Text>
                  </Button>
                </Stack>

                {isNewAdSelected ? (
                  <>
                    <Center>
                      <FormControl mt={5} w={[250, 350, 400]}>
                        <Select
                          selectedValue={payload.ad_category_id}
                          minWidth="200"
                          size="6"
                          accessibilityLabel="Ad Type"
                          placeholder="Ad Type"
                          _selectedItem={{
                            bg: "teal.600",
                          }}
                          mt="1"
                          onValueChange={(x) => {
                            const _payload = { ...payload };
                            _payload.ad_category_id = x;
                            setPayload(_payload);
                          }}
                        >
                          {adCategories.map((x, index) => {
                            return (
                              <Select.Item
                                key={index}
                                label={x.title.toString()}
                                value={x.id.toString()}
                              />
                            );
                          })}
                        </Select>
                      </FormControl>

                      <FormControl mt={2} w={[250, 350, 400]}>
                                        
                        {/* ================= IMAGE / VIDEO UPLOAD ================= */}
    
                        <Pressable
                          onPress={() => {
                            if (!youtubeLink) {
                              selectFile();
                            }
                          }}
                          isDisabled={youtubeLink?.length > 0}
                        >
                          <Input
                            isDisabled={youtubeLink?.length > 0}
                            value={
                              postImage.length > 0
                                ? `${postImage.length} file(s) selected`
                                : "Upload Images / Videos"
                            }
                            placeholder="Upload Images / Videos"
                            InputRightElement={
                              <Button
                                onPress={() => {
                                  if (!youtubeLink) {
                                    selectFile();
                                  }
                                }}
                                bgColor="gray.200"
                                isDisabled={youtubeLink?.length > 0}
                              >
                                <Icon
                                  size="6"
                                  color="muted.500"
                                  as={<MaterialIcons name="file-upload" />}
                                />
                              </Button>
                            }
                          />
                        </Pressable>
    
                        {/* ================= YOUTUBE EMBED INPUT ================= */}
                        <Text mt={1} fontSize="xs" color="gray.500">
                            OR
                        </Text>
                        <Input
                          mt={4}
                          placeholder="Paste Youtube  Link"
                          value={youtubeLink}
                          onChangeText={handleYoutubeLink}
                          isDisabled={postImage.length > 0}
                          InputRightElement={
                            <Icon
                              mr={3}
                              size="5"
                              color="red.500"
                              as={<MaterialIcons name="ondemand-video" />}
                            />
                          }
                        />
    
                        {/* ================= PREVIEW ================= */}
    
                        <HStack flexWrap="wrap" mt={3} space={2}>
                          {Array.isArray(postImage) &&
                            postImage.map((img, idx) => (
                              <Box key={idx} position="relative">
    
                                <Image
                                  source={{ uri: img }}
                                  alt="preview"
                                  size="md"
                                  borderRadius={8}
                                />
    
                                <Pressable
                                  position="absolute"
                                  top={0}
                                  right={0}
                                  bg="red.500"
                                  borderRadius="full"
                                  p={1}
                                  onPress={() => removeImage(idx)}
                                >
                                  <Icon
                                    as={<MaterialIcons name="close" />}
                                    size="xs"
                                    color="white"
                                  />
                                </Pressable>
    
                              </Box>
                            ))}
                        </HStack>
    
                      </FormControl>

                      {/* <DatePickerSingleInput
                      onChange={(x) => {
                        const _payload = { ...payload };
                        _payload.start_date = x;
                        _payload.end_date = x;
                        setPayload(_payload);
                      }}
                    /> */}

                      <FormControl mt={5} w={[250, 350, 400]}>
                        <Pressable onPress={() => setOpen(true)}>
                          <Input
                            value={
                              payload.start_date && payload.end_date
                                ? payload.start_date + " to " + payload.end_date
                                : "Select Date Range"
                            }
                            InputRightElement={
                              <Button
                                bgColor={GlobalStyles.colors.lightGrey}
                                onPress={() => setOpen(true)}
                              >
                                <Icon
                                  size="6"
                                  color="muted.500"
                                  as={<MaterialIcons name="calendar-today" />}
                                />
                              </Button>
                            }
                          />
                        </Pressable>
                      </FormControl>

                      {open ? (
                        <>
                          <DateRangePickerModel
                            onClose={(open) => {
                              setOpen(open);
                            }}
                            onChange={(startDate, endDate) => {
                              if (
                                startDate === "NaN/NaN/NaN" ||
                                endDate === "NaN/NaN/NaN"
                              ) {
                                toast.show({
                                  render: () => (
                                    <Toast
                                      color={GlobalStyles.colors.red}
                                      message="Please select a valid date range!"
                                    />
                                  ),
                                  placement: "top",
                                });
                                setOpen(false);
                                return;
                              }

                              const today = new Date();
                              today.setHours(0, 0, 0, 0);

                              const start = new Date(startDate);
                              const end = new Date(endDate);

                              if (start < today) {
                                toast.show({
                                  render: () => (
                                    <Toast
                                      color={GlobalStyles.colors.red}
                                      message="Start date cannot be before today"
                                    />
                                  ),
                                  placement: "top",
                                  duration: 3000,
                                });
                                setOpen(false);
                                return;
                              }

                              if (end < start) {
                                toast.show({
                                  render: () => (
                                    <Toast
                                      color={GlobalStyles.colors.red}
                                      message="End date must be after start date"
                                    />
                                  ),
                                  placement: "top",
                                  duration: 3000,
                                });
                                setOpen(false);
                                return;
                              }

                              // Valid dates
                              setPayload({
                                ...payload,
                                start_date: startDate,
                                end_date: endDate,
                              });
                              setOpen(false);
                            }}
                          />
                        </>
                      ) : (
                        <></>
                      )}
                     <FormControl mt={2} w={[250, 350, 400]} style={{ overflow: 'hidden' }}>

                        <Box
                            borderColor="gray.300"
                            borderWidth={1}
                            
                            p={2}
                            minHeight={150}
                            maxHeight={170} 
                            overflow="hidden" 
                            bgColor="white"
                          >
                            <ReactQuill
                              theme="snow"
                              ref={summaryRef}
                              value={postTextArea}
                              onChange={(value) => handleCountInputChange(value)}  // for web
                              onChangeText={(text) => handleCountInputChange(text)} // for android and ios
                              modules={{
                                toolbar: [
                                  
                                  ["link"],
                                ],
                              }}
                              formats={["link"]}
                              placeholder="Summary"
                              
                              // maxLength={300}
                            />
                            <style>
                            {`
                              .ql-toolbar {
                                position: sticky;
                                top: 0;
                                background-color: white;
                                z-index: 10;
                              }

                              .ql-container {
                                max-height: 110px;
                                overflow-y: auto;
                              }

                              .ql-tooltip {
                                left: 0 !important;
                                transform: translateX(0) !important;
                                max-width: 100% !important;
                                overflow: hidden !important;
                                white-space: nowrap;
                              }
                            `}
                            </style>
                          </Box>


                        </FormControl>
                        <Text alignSelf={"flex-end"} fontSize="xs" color={remainingCharacters === 0 ? "red.500" : "gray.500"}> 
                        {remainingCharacters === 0
                        ? "Character limit reached"
                        : `${remainingCharacters} characters remaining`}
                        </Text>


                        <FormControl mt={2} w={[250, 350, 400]} style={{ overflow: 'hidden' }}>
                        <Box
                          borderColor="gray.300"
                          borderWidth={1}
                          
                          p={2}
                          minHeight={150}
                          maxHeight={170} 
                          overflow="hidden" 
                          bgColor="white"
                        >
                          <ReactQuill
                            theme="snow"
                            ref={detailRef}
                            value={postDetails}
                            onChange={(value) => handleCountInputChangeForDetail(value)} // for web
                            onChangeText={(text) => handleCountInputChangeForDetail(text)} // for android and ios
                            modules={{
                              toolbar: [
                                
                                ["link"],
                              ],
                            }}
                            formats={["link"]}
                            placeholder="Write the details here..."
                            // maxLength={1500}
                          />
                        </Box>
                        </FormControl>
                        <Text alignSelf={"flex-end"} fontSize="xs" color={remainingCharactersForDetail === 0 ? "red.500" : "gray.500"}> 
                        {remainingCharactersForDetail === 0
                        ? "Character limit reached"
                        : `${remainingCharactersForDetail} characters remaining`}
                        </Text>
                      {/* <FormControl mt={5} w={[230, 230, 230]}>
                        <TextArea
                          borderWidth={1}
                          placeholder="Write Something..."
                          // value={postTextArea}
                          onChange={(e) =>
                            (payload.text = e.currentTarget.value)
                          } // for web
                          onChangeText={(text) => (payload.text = text)} // for android and ios
                        />
                      </FormControl> */}

                      <Button
                        mt="5"
                        size="sm"
                        variant={"solid"}
                        px="3"
                        bg={GlobalStyles.colors.blue}
                        borderColor={GlobalStyles.colors.mustard}
                        borderWidth={2}
                        onPress={Submit}
                        // isDisabled={isLoading}
                      >
                        Submit
                      </Button>
                    </Center>
                  </>
                ) : (
                  <></>
                )}

                {isCurrentAdsSelected || isAnalyticsSelected ? (
                  <>
                    <ScrollView
                      w={[360, 460, 610]}
                      showsVerticalScrollIndicator={false}
                    >
                      <VStack alignItems="center">
                        <Stack
                          justifyContent="center"
                          flexDirection={"row"}
                          space={3}
                          flexWrap="wrap"
                          m={2}
                        >
                          {ads.map((x, index) => {
                            return (
                              <AdCardForBusiness
                                data={x}
                                showViewCount={isAnalyticsSelected}
                                setSelectedPost={onDeleteClick}
                              />
                            );
                          })}
                        </Stack>
                      </VStack>
                      {/* {ads.length >= 10 && hasMorePosts && (
                          <Stack
                            w={[190, 190, 190]}
                            alignSelf="center"
                            
                          >
                            <Button
                              size="sm"
                              bg={GlobalStyles.colors.blue}
                              onPress={loadMorePosts}
                              isLoading={isLoadingMore} 
                              isLoadingText="Loading..."
                            >
                              <Text
                                fontWeight="bold"
                                fontFamily={GlobalStyles.text.fontFamily}
                                color={GlobalStyles.colors.white}
                              >
                                Load More
                              </Text>
                            </Button>
                          </Stack>
                        )} */}
                    </ScrollView>
                  </>
                ) : (
                  <></>
                )}
              </VStack>
            </Box>
          </Center>
          {submitPopUp ? (
            <ConfigureSettingsPopup
              heading="Ad Submitted"
              body="Your ad is under review. When it becomes visible in the field, we will notify you."
              data={submitPopUp}
              onChange={handleChange}
            />
          ) : (
            <></>
          )}

          {deletePopUp ? (
            <ConfigureSettingsPopup
              heading="Confirm Deletion"
              body="Are you sure you want to delete"
              data={deletePopUp}
              onChange={handleDeleteOk}
            />
          ) : (
            <></>
          )}

          {isShowPayNow ? (
            <ConfigureSettingsPopup
              heading="Payment Details"
              body={
                "Are you sure you want to pay amount $" + payNowPayload.amount
              }
              data={isShowPayNow}
              onChange={handlePayNow}
            />
          ) : (
            <></>
          )}

          {showPayNowCard ? (
            <StripePopup
              heading={"Confirm Payment"}
              body={payNowPayload}
              data={showPayNowCard}
              onChange={handleChange}
            />
          ) : (
            <></>
          )}
        </Box>
      </ScrollView>
        {(isCurrentAdsSelected || isAnalyticsSelected) && showUpButton  && (
          <IconButton
          position="absolute"
          bottom={10}
          right={10}
          borderRadius="full"
          bg={GlobalStyles.colors.blue}
          _pressed={{ bg: "gray.500" }}
          icon={<ChevronUpIcon color="white" size={6} />}
          onPress={scrollToTop}
        />
        )}
    </>
  );
};

export default AdvertiserMainPage;
